import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAlertsStore } from '@/features/alerts/store';
import { cn } from '@/lib/utils';

/** 顶栏告警铃 — 未确认计数 + 跳转 §9.14 告警中心 */
export function AlertsBell() {
  const navigate = useNavigate();
  const count = useAlertsStore((s) => s.alerts.reduce((n, a) => (a.ack ? n : n + 1), 0));
  const hasCrit = useAlertsStore((s) => s.alerts.some((a) => !a.ack && a.severity === 'CRIT'));

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => navigate('/alerts')}
      aria-label={`告警中心 · ${count} 条未确认`}
      title={count > 0 ? `${count} 条未确认告警` : '无未确认告警'}
      className="relative"
    >
      <Bell className={cn('h-4 w-4', hasCrit && 'animate-pulse-glow text-down')} />
      {count > 0 && (
        <span
          className={cn(
            'absolute -top-1 -right-1 h-4 min-w-4 px-1 rounded-full text-[10px] font-bold flex items-center justify-center text-white num',
            hasCrit ? 'bg-down' : 'bg-warn',
          )}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Button>
  );
}
